export const TRIP_STATUS = [
    { value: 10, label: 'PEDIDO' , color: 'black' },
    { value: 20, label: 'EN RUTA' , color: 'orange' },
    { value: 30, label: 'EN REVISIÓN' , color: 'yellow' },
    { value: 40, label: 'REVISADO' , color: 'green' },
    { value: 50, label: 'FACTURADO' , color: 'blue' },
    { value: 60, label: 'ARCHIVADO' , color: 'gray' },
]


export const STOCK_MOVEMENT_TYPE = [
    { label: 'Entrada', value: 'in' },
    { label: 'Salida', value: 'out' },
]

export const CONFIG_OPTIONS = [
        { label: 'IVA por defecto', value: 'iva_default' },
        { label: 'Límite de facturación de proveedor', value: 'limite_facturacion_proveedor' },
        { label: 'Umbral de stock bajo', value: 'umbral_stock_bajo' },
]
